import { createSlice } from "@reduxjs/toolkit";

const importExportProducts = createSlice({
  name: "importExportProducts",
  initialState: {
    data: {},
  },
  reducers: {
    getAvailableProducts(state, action) {
      state.data = action.payload;
      state.loading = false;
    },

  },
});

export const { getAvailableProducts } = importExportProducts.actions;
export default importExportProducts.reducer;
